// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-scroll-to-top[data-v-8314f794]{position:fixed;bottom:5%;z-index:99;opacity:0;transition:all .5s ease}[dir=ltr] .btn-scroll-to-top[data-v-8314f794]{right:30px}[dir=rtl] .btn-scroll-to-top[data-v-8314f794]{left:30px}.btn-scroll-to-top.show[data-v-8314f794]{opacity:1}", ""]);
// Exports
module.exports = exports;
